import React from 'react'
import { Image, View } from '@react-pdf/renderer'
import QRCodeLib from 'qrcode'

interface QRCodeProps {
  value: string
  size?: number
  errorCorrectionLevel?: 'L' | 'M' | 'Q' | 'H'
}

export function QRCode({ 
  value, 
  size = 80, 
  errorCorrectionLevel = 'M' 
}: QRCodeProps) {
  const [qrCodeDataUrl, setQrCodeDataUrl] = React.useState<string>('')

  React.useEffect(() => {
    const generateQR = async () => {
      try {
        const dataUrl = await QRCodeLib.toDataURL(value, {
          width: size,
          margin: 1,
          errorCorrectionLevel,
          type: 'image/png'
        })
        setQrCodeDataUrl(dataUrl)
      } catch (error) {
        console.error('QR Code generation failed:', error)
      }
    }

    if (value) {
      generateQR()
    }
  }, [value, size, errorCorrectionLevel])

  if (!qrCodeDataUrl) {
    return null
  }

  return (
    <View style={{ width: size, height: size }}>
      <Image 
        src={qrCodeDataUrl}
        style={{ 
          width: size, 
          height: size,
          objectFit: 'contain'
        }}
      />
    </View>
  )
}